<template>
  <div class="item-base">
    <div class="item-left">
      <pre>
        {{concept.description}}
      </pre>
    </div>
     <div class="item-right">
        <el-image :src="'http://'+concept.photoUrl" class="img" fit="cover" v-if="concept.photoUrl"></el-image>
       <div class="right-bg">

       </div>
     </div>
  </div>
</template>

<script>
  export default {
    name: "ServiceConcept",
    created() {
      this.GetData()
    },
    data(){
      return{
        concept:null,
      }
    },
    methods:{
      GetData(){
        this.$axios.get('/api/after/getAll').then(res=>{

          this.concept=res.data.data[0];
          // this.Tel=res.data.data[1];
          // this.PXun=res.data.data[2];
          // this.CZuo=res.data.data[4];
          // this.QDong=res.data.data[3];

        })
      },
    }
  }
</script>

<style lang="less" scoped>
.item-base {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .item-left{
    display: flex;
    align-items: center;
    width: 657px;
    pre{
      font-size: 24px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #333333;
      line-height: 36px;
    }
  }
  .item-right{
    width: 657px;
    position: relative;

    .img{
      width: 657px;
      height: 486px;
      z-index: 6;
    }
    .right-bg{
      width: 679px;
      height: 486px;
      background: #188ACB;
      opacity: 0.5;
      position: absolute;
      top: 40px;
      left: 25px;
      z-index: 1;
    }
  }
}
</style>